import React, { useContext } from "react";
import { Button } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";


const ResetSetId = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { closeModal } = rootStore.modalStore;
  const { resetTestSet } = rootStore.companyStore;

  return (
    <div className="modalContent">
      <label>Al aceptar el cambio del identificador, se reiniciará todo el proceso del set de pruebas</label>
      <br />
      <br />  
      <label>¿Desea de continuar? </label>          
      <Button color="red" inverted onClick={() => closeModal()}>
        No
      </Button>
      <Button
        positive
        onClick={() => resetTestSet()}
        icon="checkmark"
        content="Si"
      />
    </div>
  );
};
export default ResetSetId;